<div class="main-wrapper">
  <div class="wrapper dashboard-wrapper">
    <div class="my-container">
        <div class="status-widget-container">
          <div class="error-container plain page-level mt-5 pt-5">
            <img src="assets/images/new-set/401.svg" alt="" class="big-thumbnail">
            <h4 class="error-title">Unauthorized (Authentication required)</h4>
            <p class="error-subtitle">Authentication failed. Your session may have expired, or your credentials are incorrect.</p>
            <p class="error-subtitle"><a (click)="logout()" style="display: inline !important; color: blue;">Click here</a> to re-login</p>
          </div>
      </div>
    </div>
  </div>
</div>